// Global Mute shows friendlier product names than the app-wide DataSourceMapping.
// Effective from the 30th release: "Video" (was VSI) and "App" (was DPI); "Ad"
// is unchanged. Kept local to Global Mute so the rename does not affect the rest
// of the app.
export const GLOBAL_MUTE_PRODUCT_LABEL: Record<string, string> = {
  ei: 'Video',
  ai: 'Ad',
  app: 'App',
};

export const getGlobalMuteProductLabel = (mode: string): string =>
  GLOBAL_MUTE_PRODUCT_LABEL[(mode || '').toLowerCase()] || (mode || '').toUpperCase();
